import React from 'react'
import { FormikProvider, Field } from 'formik'
import Button from '../../../components/Form/Button'
import Input from '../../../components/Form/Input'

interface UpdateCredentialsFormProps {
  formik: any
  showUpdateCredentialsForm: boolean
  setShowUpdateCredentialsForm: (showUpdateCredentialsForm: boolean) => void
  showShortNameField?: boolean
  linkMode?: boolean
  onOpenForm?: () => void
}

const UpdateCredentialsForm: React.FC<UpdateCredentialsFormProps> = ({
  formik,
  showUpdateCredentialsForm,
  setShowUpdateCredentialsForm,
  showShortNameField = false,
  linkMode = false,
  onOpenForm,
}) => {
  return (
    <>
      {!showUpdateCredentialsForm && (
        <div className="flex flex-col justify-between items-center">
          <Button
            onClick={() => {
              if (onOpenForm != null) {
                onOpenForm()
              } else {
                setShowUpdateCredentialsForm(true)
              }
            }}
          >
            {linkMode ? 'Link Portal...' : 'Update Credentials...'}
          </Button>
        </div>
      )}
      {showUpdateCredentialsForm && (
        <FormikProvider value={formik}>
          <form onSubmit={formik.handleSubmit}>
            <div className="flex flex-col justify-between items-center">
              <div className="flex flex-row justify-between items-end">
                <div className={`grid gap-4 ${showShortNameField ? 'grid-cols-1' : 'grid-cols-2'}`}>
                  <Field label="Username" id="username" name="username" type="text" as={Input} required error={formik.errors.username} />
                  <Field label="Password" id="password" name="password" type="password" as={Input} required error={formik.errors.password} />
                  {showShortNameField && (
                    <>
                      <Field
                        label="Scraper short name"
                        id="shortName"
                        name="shortName"
                        type="text"
                        as={Input}
                        required
                        error={formik.errors.shortName}
                      />
                      <p className="text-sm text-slate-500 dark:text-slate-400">
                        Unique identifier used by scraper jobs.
                      </p>
                    </>
                  )}
                </div>
              </div>
              <div className="mt-4 w-full flex flex-row justify-center items-center">
                <Button type="submit" className="w-full">
                  {linkMode ? 'Link' : 'Update'}
                </Button>
                <Button
                  className="w-full ml-4"
                  onClick={() => {
                    setShowUpdateCredentialsForm(false)
                  }}
                  color="slate"
                >
                  Cancel
                </Button>
              </div>
            </div>
          </form>
        </FormikProvider>
      )}
    </>
  )
}

export default UpdateCredentialsForm
